import { useMemo } from 'react'

import { useFetchJournals } from '@features/journals/hooks/useFetchJournals'

import {
  getTransactionsFilterJournalCodes,
  TransactionsFilterJournalCode,
} from '../utils/getTransactionsFilterJournalCodes'

interface UseTransactionsFilterJournalCodesProps {
  isDisabled?: boolean
}

/* We have a set of permanent journal codes but users can create new journals */
/* Permanent journals are not fetched with useFetchJournals request, so we need to merge them manually */
export const useTransactionsFilterJournalCodes = ({
  isDisabled,
}: UseTransactionsFilterJournalCodesProps = {}): TransactionsFilterJournalCode[] => {
  const { journals } = useFetchJournals({ isDisabled })

  return useMemo(() => {
    const permanentJournalCodes = getTransactionsFilterJournalCodes()
    const permanentCodes = new Set(permanentJournalCodes.map(({ value }) => value))

    const customJournalCodes = journals
      .filter(({ code }) => !permanentCodes.has(code))
      .map(({ code, name }) => ({ label: `${name} (${code})`, value: code }))

    return [...permanentJournalCodes, ...customJournalCodes]
  }, [journals])
}
